import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { BUILD_VERSION } from './version';

// Enforce canonical domain — redirect dev/preview URLs to production
const CANONICAL_HOST = 'bos.sandland.us';
if (
  typeof window !== 'undefined' &&
  window.location.hostname !== CANONICAL_HOST &&
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1'
) {
  window.location.replace(
    `https://${CANONICAL_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

// Log build version to console for verification
console.log(
  '%c BizOps Build Info ',
  'background: #6366f1; color: white; font-size: 14px; padding: 4px 8px; border-radius: 4px;',
  `\n  ID: ${BUILD_VERSION.id}\n  Built: ${BUILD_VERSION.timestamp}\n  Git: ${BUILD_VERSION.git}`
);

// Make version available globally for easy checking
(window as any).__BIZOPS_VERSION__ = BUILD_VERSION;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
